<template>
  <div v-if="savedSchool" id="SavedSchoolInfo" class="wrap">
    <div class="maxContainer">
      <v-app-bar  prominent class=" white hidden-md-and-up  " fixed  elevate-on-scroll height={this.fixedHeaderFixerVal} >
        <v-layout  class="mt-1"   column align-center justify-center ref="fixedHeaderFixer">
          <v-layout row align-center justify-center >
            <span v-bind:class="{ 'mt-4' : savedSchool.school_name.length <= 25 }" class=" headline font-weight-medium text-center light-blue--text text--darken-4 "> {{ savedSchool.school_name }}</span>
          </v-layout>
          <v-layout  class="mt-3 " row align-center justify-center >
            <v-layout >
              <Report/>
            </v-layout>
            <v-layout ml-1 column align-center justify-center>
              <RemoveSavedSchools :savedSchool='savedSchool' />
            </v-layout>
          </v-layout>

        </v-layout>
      </v-app-bar >

        <div class="headerFake" >
          <div class="maxContainer  hidden-sm-and-down">
            <div @click="back" class="headerFake__back">
              <a class="headerFake__backLink">
                <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
                <span class="headerFake__backText">Back</span>
              </a>
            </div>

            <v-toolbar-title class="mb-3">{{ savedSchool.school_name }}</v-toolbar-title>

            <div class="flex-grow-1"></div>

              <v-layout align-center justify-center>
                <Report/>
                <RemoveSavedSchools :savedSchool='savedSchool' />
              </v-layout>

             <div class="headerFake__buttonCover">
              <v-btn
                fab
                small
                color="white"
                :href="`tel:${savedSchool.program_phone_number}`"
              >
                <v-icon color="blue darken-3" >mdi-phone-outline</v-icon>
                <span class="caption grey--text mt-1">Phone</span>
              </v-btn>

             <v-btn
              fab
              small
              color="white"
              :href="`mailto:${savedSchool.program_email}`"
            >
              <v-icon color="blue darken-3">mdi-email-outline</v-icon>
              <span class="caption grey--text mt-1">E-mail</span>
            </v-btn>

            <v-btn
              fab
              small
              color="white"
              @click="showAddressDialog = true"
            >
              <v-icon color="blue darken-3">mdi-map-marker-outline</v-icon>
              <span class="caption grey--text mt-1">Address</span>
            </v-btn>

             <v-btn
              fab
              small
              color="white"
              :href="savedSchool.program_website"
              target="_blank"
            >
              <v-icon color="blue darken-3">mdi-monitor</v-icon>
              <span class="caption grey--text mt-1">Website</span>
            </v-btn>
            </div>
          </div>
        </div>
    <v-container   pt-0 pl-0 pr-0>
     <v-row >
        <v-col  lg=“6”>
          <v-tabs
            v-model="tab"
            background-color="transparent"
            hide-slider
            grow
            :style="{marginTop: this.spacingTop}"
            >
            <v-tab active-class="grey darken-3 white--text" style="marginLeft:0px;">
              <v-icon class="mr-2" small>mdi-information</v-icon>
              Info
            </v-tab>
           
            <v-tab active-class="grey darken-3 white--text">
              <v-icon class="mr-2" small>mdi-chart-line</v-icon>
              Requirements
            </v-tab>
             <v-tab active-class="grey darken-3 white--text" v-if="faqs.length">
              <v-icon class="mr-2" small>mdi-frequently-asked-questions</v-icon>
              FAQ
            </v-tab>
            <v-tab active-class="grey darken-3 white--text">
               <v-icon class="mr-2" small>mdi-message-reply-text</v-icon>
               Messages
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <!-- NEW DESIGN -->
            <!-- Program Info -->
            <v-tab-item style=" marginBottom:30px">
              <v-card class="card pt-1 "  flat >
                <v-container >
                  <v-layout hidden-md-and-up>
                    <!-- Phone Number -->
                      <v-layout column align-center justify-center>
                        <a :href="`tel:${savedSchool.program_phone_number}`">

                            <v-btn small icon  color="light-blue darken-3">  <v-icon color="light-blue darken-3">mdi-phone-outline</v-icon></v-btn>
                        </a>
                        <span class="caption grey--text mt-1">Call</span>
                      </v-layout>


                      <!-- Email -->
                      <v-layout column align-center justify-space-between >
                        <a :href="`mailto:${savedSchool.program_email}`">
                          <v-btn  icon small   color="light-blue darken-3"> <v-icon color="light-blue darken-3">mdi-email-outline</v-icon>
                          </v-btn>
                        </a>
                        <span class="caption grey--text mt-1">Email</span>
                      </v-layout>

                      <!-- Address -->
                      <v-layout column align-center justify-center>
                        <v-btn @click="showAddressDialog = true" icon small  > <v-icon color="light-blue darken-3">mdi-map-marker-outline</v-icon></v-btn>
                        <span class="caption grey--text mt-1">Address</span>
                      </v-layout>

                      <!-- Address Dialog -->
                      <v-dialog
                        v-model="showAddressDialog"
                        scrollable
                        max-width="400"
                        persistent
                        style="zIndex:2000"
                        >
                        <v-card>
                          <v-card-title class="title light-blue darken-3 text-xs-center white--text">
                            <v-icon color="white" large class="mr-3">mdi-map-marker-outline</v-icon>
                            Program Address
                          </v-card-title>

                          <v-card-text class="text-xs-justify pb-0 mt-2" >
                            <v-layout column  pl-2>
                              <p class=" subheading mb-1 black--text"> {{savedSchool.program_address}}</p>
                              <p class=" subheading mb-1 black--text"> {{savedSchool.program_city}}, {{savedSchool.program_state}}</p>
                              <p class=" subheading mb-1 black--text"> {{savedSchool.program_zip_code}}</p>
                            </v-layout>
                          </v-card-text>

                          <v-card-actions class="pb-2  ">
                            <v-spacer></v-spacer>
                            <v-btn
                              color="red"
                              block
                              dark
                              class="elevation-0"
                              @click="showAddressDialog = false"
                            >
                              Close
                            </v-btn>
                          </v-card-actions>

                        </v-card>
                      </v-dialog>

                      <!-- SCHOOL WEBSITE -->
                      <v-layout column align-center justify-center>
                          <a :href="savedSchool.program_website" target="_blank">
                          <v-btn  icon small   > <v-icon color="light-blue darken-3">mdi-monitor</v-icon></v-btn>
                          </a>
                          <span class="caption grey--text mt-1">Website</span>
                      </v-layout>
                  </v-layout>
                </v-container>
                <!-- Accreditation Status  -->

                  <v-card  id="buttonShadow" >
                    <v-layout align-center justify-center  class="grey lighten-4 pb-2">
                      <span class="title font-weight-regular  align-center mt-1">Accreditation Status   <v-icon @click="showStatusDialog = true" small class="ml-1 mb-1">mdi-information</v-icon> </span>
                    </v-layout>


                    <v-layout column justify-center align-center mt-1 mb-1 pb-4 pt-2 >
                      <span class="title"><span  :class="{ 'red--text' : savedSchool.accreditation_status === 'Withheld', 'amber--text text--darken-3' : savedSchool.accreditation_status === 'Probationary', 'blue--text text--lighten-1' : savedSchool.accreditation_status === 'Provisional', 'green--text' : savedSchool.accreditation_status === 'Continued', 'grey--text' : savedSchool.accreditation_status === 'Developing-Not Accredited' }">{{savedSchool.accreditation_status}}</span></span>

                    </v-layout>
                  </v-card>


                <!-- Accredidation Dialog Status -->
                <v-dialog
                  v-model="showStatusDialog"
                  scrollable
                  max-width="400"
                  persistent
                  style="zIndex:2000"
                  >
                  <v-card style="borderRadius:10px" >
                    <v-card-title class="title grey lighten-2 text-xs-center mb-2">
                      Accredidation - {{savedSchool.accreditation_status}}
                    </v-card-title>
                    <v-card-text class="text-xs-justify mt-1"  v-if="savedSchool.accreditation_status === 'Continued'">
                      Accreditation-Continued is granted 1) when a currently accredited program is in compliance with the Standards, 2) in the case of a program holding Accreditation-Probation when the program has demonstrated that it is once again in compliance with the Standards, or 3) when a program holding Accreditation-Provisional demonstrates compliance with the Standards after completion of the provisional review process. Accreditation-continued status remains in effect until the program closes or withdraws from the accreditation process or until accreditation is withdrawn for failure to comply with the Standards.
                    </v-card-text>

                    <v-card-text class="text-xs-justify mt-1" v-if="savedSchool.accreditation_status === 'Provisional'">
                      Accreditation–Provisional is an accreditation status granted when the plans and resource allocation, if fully implemented as planned, of a proposed program that has not yet enrolled students appear to demonstrate the program’s ability to meet the ARC-PA Standards or when a program holding accreditation-provisional status appears to demonstrate continued progress in complying with the Standards as it prepares for the graduation of the first class (cohort) of students.
                    </v-card-text>

                    <v-card-text class="text-xs-justify mt-1" v-if="savedSchool.accreditation_status === 'Probationary'">
                      Accreditation-Probation is a temporary, status of accreditation, limited to two years, granted when a program holding an accreditation status of accreditation-provisional or accreditation-continued does not meet the Standards and when the capability of the program to provide an acceptable educational experience for its students is threatened.  Once placed on probation, a program that fails to comply with accreditation requirements in a timely manner, as specified by the ARC-PA, may be scheduled for a focused site visit and/or risk having its accreditation withdrawn.
                    </v-card-text>

                    <v-card-text class="text-xs-justify mt-1" v-if="savedSchool.accreditation_status === 'Administrative Probation'">
                     Accreditation-Administrative Probation is a temporary status granted when a program has not complied with an administrative requirement, such as failure to pay fees or submit required reports. Once placed on Administrative Probation, a program that fails to comply with administrative requirements in a timely manner, as specified by the ARC-PA, may be scheduled for a focused site visit and/or risk having its accreditation withdrawn.
                    </v-card-text>

                    <v-card-text class="text-xs-justify mt-1" v-if="savedSchool.accreditation_status === 'Withheld'">
                     Accreditation Withheld is a status granted when a PA program, seeking accreditation-provisional is not in compliance with the Standards. The program receiving this accreditation status may voluntarily withdraw from the accreditation process within the 30-day appeal timeframe.
                    </v-card-text>

                    <v-card-text class="text-xs-justify mt-1" v-if="savedSchool.accreditation_status === 'Developing-Not Accredited'">
                     The PA Program is working towards accreditation, but has not yet passed ARC-PA accreditation review. There is no guarantee the program will be accredited.
                    </v-card-text>

                    <v-card-text class="text-xs-justify mt-0 pt-0" >
                    <span>You can read more about PA School accreditation status at <a href="http://www.arc-pa.org/accreditation/accreditation-types-review-cycle/" class="blue--text  ">ARC-PA Accreditation Types and Review </a></span>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn @click="showStatusDialog = false"  block color="red" dark  class="elevation-0">Close</v-btn>
                    </v-card-actions>

                  </v-card>
                </v-dialog>




                <ProgramInfo :school="savedSchool" class="mt-5"/>

                <!-- Application info -->
                <Application :school="savedSchool"/>



                <!-- CASPA Deadline Type DIALOG -->
                <v-dialog
                  v-model="showCaspaDeadlineTypeDialog"
                  scrollable
                  max-width="400"
                  persistent
                  style="zIndex:2000"
                  >

                  <v-card style="borderRadius:5px">
                    <v-card-title class="title grey lighten-2 text-xs-center mb-2">
                      CASPA Deadline Type - {{savedSchool.application_deadline_type | capitalizeString}}

                    </v-card-title>
                    <!-- Verified -->
                    <v-card-text class="text-xs-justify"  v-if="savedSchool.application_deadline_type === 'verified'">
                      Applications must be verified by 11:59 PM ET on the deadline date. Applications can only be verified once all payments, transcripts, and letters of evaluation have been received. To ensure your application is verified on time, try to complete your application at least four weeks before the deadline.
                    </v-card-text>
                    <!-- Completed -->
                    <v-card-text class="text-xs-justify"  v-if="savedSchool.application_deadline_type && savedSchool.application_deadline_type.toLowerCase() === 'completed'">
                      Application, payments, transcripts, and at least two letters of evaluation must be received by 11:59 PM ET on the deadline date. To ensure items arrive on time, try to send all documents several weeks before the deadline.
                    </v-card-text>
                    <!-- Submitted -->
                    <v-card-text class="text-xs-justify"  v-if="savedSchool.application_deadline_type === 'submitted'">
                      Applications must be submitted by 11:59 PM ET on the deadline date. Program materials do not have to be received by the deadline date.
                    </v-card-text>
                    <v-card-text class="text-xs-justify mt-0 pt-0" >
                      <span>You can read more about CASPA deadline types at <a href="https://help.liaisonedu.com/CASPA_Applicant_Help_Center/Starting_Your_CASPA_Application/Getting_Started_with_Your_CASPA_Application/3_CASPA_Participating_Programs_and_Eligibility" class="blue--text  ">CASPA Deadlines </a></span>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn @click="showCaspaDeadlineTypeDialog = false" block flat color="red" class="elevation-0" dark >Close</v-btn>
                    </v-card-actions>
                  </v-card>

                </v-dialog>

                <!-- Program Information -->
              <v-card v-if="savedSchool.mission_statement" flat class="mt-6">
                <MissionStatement :school="savedSchool"/>
              </v-card>


              </v-card>

               <v-alert type="info" outlined text dense style="marginBottom:0px; marginTop:0px">
                <span>Information is subject to change by the PA program at any time. If you notice an error please report it to us by clicking the "Report" button above". Thank you for helping us keep myPAbox the most reliable resource for the pre-PA community. - myPAbox Team</span>
                
              </v-alert>
            </v-tab-item>

            <!-- Requirement Tracker -->
            <v-tab-item  style="marginBottom:30px">
                <!-- Required Tasks -->
                <v-card  outlined class="mt-5 pb-5 ">
                  <v-layout column align-center justify-center class="grey lighten-4 pb-2 ">
                    <span class="title font-weight-regular red--text align-center mt-1">Required Tasks </span>
                  </v-layout>

                  <!-- School Progress Bar -->
                  <v-layout class="mx-2 mt-2"  >
                      <v-progress-linear
                        :color="changeColor"
                        height="22"
                        :value="progressStats.passed / progressStats.total * 100 "
                        rounded
                        bottom
                        reactive
                      >
                      <span class="white--text font-weight-bold">{{Math.ceil(progressStats.passed / progressStats.total * 100)}}% completed</span>
                      </v-progress-linear>
                  </v-layout>

                  <!-- Required Degree -->
                  <Degree :savedSchool="savedSchool"/>

                  <!-- Minimum GPA  -->
                  <GPA :savedSchool="savedSchool" />

                   <!-- Prerequistes -->
                  <Prerequisites :savedSchool="savedSchool"/>

                  <!-- Healthcare Hours -->
                  <HealthcareExperience :savedSchool="savedSchool"/>

                  <!-- PA Shadowing -->
                  <PaShadowing :savedSchool="savedSchool"/>

                  <!-- Evaluations -->
                  <Evaluation :savedSchool="savedSchool"/>

                  <!-- GRE -->
                  <Gre :savedSchool="savedSchool"/>

                  <!-- CASPer -->
                  <Casper :savedSchool="savedSchool"/>

                  <!-- PA-CAT -->
                  <Pacat :savedSchool="savedSchool"/>

                  <!-- International Students -->
                  <InternationalExams :savedSchool="savedSchool"/>





                </v-card>

                 <!-- Recommended Tasks -->
                <v-card  v-if="savedSchool.recommended_courses[0] !== 0 || savedSchool.healthcare_experience_recommended || savedSchool.pa_shadowing_recommended=== true || savedSchool.casper_recommended === true || savedSchool.pacat_recommended || savedSchool.letter_of_recommendation_recommended " outlined class="mt-5 pb-5">
                  <v-layout row align-center justify-center class="grey lighten-4 pb-2 mx-0">
                    <span class="title font-weight-regular amber--text text--darken-3 align-center mt-1">Recommended Tasks </span>
                  </v-layout>

                  <!-- Recommended Courses -->
                  <v-expansion-panels  v-if="savedSchool.recommended_courses[0] !== 0" focusable class="px-2 mt-3 ">
                    <v-expansion-panel class="mt-2  "  >
                      <v-expansion-panel-header  class="light-blue--text text--darken-4">
                        <v-layout row align-center pb-0 >
                          <v-icon color="amber darken-3" >mdi-thumb-up</v-icon>
                          <v-icon color="blue darken-3" class="ml-2">mdi-text-box-multiple</v-icon>
                          <span class="ml-2 blue--text text--darken-3 font-weight-medium">Recommended Courses</span>
                        </v-layout>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content eager class=" px-0 mx-0 pb-0 elevation-0 ">
                          <div >
                            <v-list two-line class="pt-0 pb-0 ml-3" >
                              <v-list-item-group  >
                                <template v-for="(recommendedCourse, index) in savedSchool.recommended_courses" >
                                  <v-list-item :key="recommendedCourse.id" class="pl-0 " style="maxHeight:10px" >

                                      <v-list-item-content class="pa-0">
                                        <v-list-item-title class="light-blue--text text--darken-3">
                                          <v-layout align-center>{{ recommendedCourse.course_name }} </v-layout>
                                          </v-list-item-title>
                                          <v-list-item-subtitle  v-if="Array.isArray(recommendedCourse.lab )"  class="text--primary font-weight-light" >
                                            <span class="">{{ recommendedCourse.lab[0] }} </span>
                                          </v-list-item-subtitle>
                                            <v-list-item-subtitle  v-else class="text--primary font-weight-light" >
                                            <span class=""> {{ recommendedCourse.lab }} </span>
                                          </v-list-item-subtitle>

                                        <v-list-item-subtitle  v-if="recommendedCourse.credits !== '' && recommendedCourse.credits !== undefined" class="text--primary font-weight-light" >
                                          <span >{{ recommendedCourse.credits }} credits  <span v-if="recommendedCourse.semester !== '' && recommendedCourse.semester !== undefined " >or</span></span>
                                          <span v-if="recommendedCourse.semester !== '' && recommendedCourse.semester !== undefined " >  {{ recommendedCourse.semester }} semester hrs</span>
                                          <span v-if="recommendedCourse.quarter !== '' && recommendedCourse.quarter !== undefined" > or {{ recommendedCourse.quarter}} quarter hrs</span>
                                        </v-list-item-subtitle>


                                      </v-list-item-content>


                                  </v-list-item>


                                  <v-divider
                                    v-if="index + 1 < savedSchool.recommended_courses.length"
                                    :key="index"

                                  ></v-divider>
                                </template>

                              </v-list-item-group>
                            </v-list>
                          </div>

                          <!-- Prerequisite Notes -->
                          <v-card  v-if="savedSchool.prerequistesNotes" outlined class=" mt-4 mb-4">
                            <v-layout align-center justify-center class=" pb-1" >
                              <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
                              <span class="font-weight-light align-center"> Additional Notes </span>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-card-text class="text-center">
                              <span>{{savedSchool.prerequistesNotes}}</span>
                            </v-card-text>
                          </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Recommended Healthcare Hours -->
                  <v-expansion-panels  v-if="savedSchool.healthcare_experience_recommended" focusable class="px-2 mt-3 ">
                    <v-expansion-panel class="mt-2  "  >
                      <v-expansion-panel-header  class="light-blue--text text--darken-4">
                        <v-layout row align-center pb-0 >
                          <v-icon color="amber darken-3" >mdi-thumb-up</v-icon>
                          <v-icon color="blue darken-3" class="ml-2">mdi-hospital-box</v-icon>
                          <span class="ml-2 blue--text text--darken-3 font-weight-medium">Experience Hours</span>
                        </v-layout>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content eager class=" px-0 mx-0 pb-0 elevation-0 ">

                        <!-- Recommended Healthcare Hours -->
                        <v-card  class="pb-3 mt-3 innerCardCover elevation-0" style="borderRadius:5px" outlined>
                          <v-layout  justify-center class="amber darken-3 pb-2">
                            <span class="white--text text-center mt-2">Experience Hours Recommended</span>
                          </v-layout>

                          <v-tabs
                            v-model="recommendedHealthcareHoursTab"
                            background-color="transparent"
                            color="basil"
                            grow
                            class="mt-3 px-2"
                            hide-slider
                            >
                            <v-tab active-class="grey darken-2 white--text" style="marginLeft:0px;">
                              Recommended Hrs
                            </v-tab>

                            <v-tab active-class="primary white--text">
                            <v-icon small class="mr-2" >mdi-account-circle</v-icon>
                              My Hours
                            </v-tab>
                          </v-tabs>

                          <v-tabs-items v-model="recommendedHealthcareHoursTab">
                            <!-- Recommended Hours Tab Item -->
                            <v-tab-item class="pb-2">
                              <v-layout  v-if="savedSchool.healthcare_experience_recommended" mt-4 column align-center justify-center>
                                  <v-progress-circular  v-if="savedSchool.healthcare_experience_minimum_hours !== ''" :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium amber--text text--darken-3" >{{savedSchool.healthcare_experience_minimum_hours}}</span></v-progress-circular>
                                  <span v-if="savedSchool.healthcare_experience_minimum_hours === '' " class=" mt-2 mb-0  body-1 font-weight-light ">No Specified Hours</span>
                                  <span  v-if="savedSchool.healthcare_experience_minimum_hours !== ''" class="mt-1 font-weight-light">Hours</span>
                                </v-layout>

                                <!-- Accepted Experience Card -->
                                <v-card
                                  v-if="savedSchool.healthcare_experience_recommended"
                                  style="borderRadius:5px" outlined class="mt-4 mx-2"
                                  >
                                  <v-layout justify-center class=" grey lighten-3 pb-2 ">
                                    <span class="subtitle-1 mt-2 font-weight-regular">  Accepted Experience </span>
                                    <v-icon @click="showAcceptedExpDialog = true" small class=" ml-2">mdi-information</v-icon>
                                  </v-layout>

                                  <v-card-text class="pt-2  ">
                                    <v-layout  column class="pl-0 ml-0 ">
                                      <v-layout v-if="savedSchool.healthcare_experience_direct_paid_patient_hours === false && savedSchool.healthcare_experience_direct_patient_hours === false && savedSchool.healthcare_experience_indirect_patient_hours === false && savedSchool.healthcare_experience_volunteer_hours === false" align-center justify-space-between >
                                        <span class="">Any experience accepted</span>
                                        <v-icon color="green" class="" size="20px">mdi-check-circle</v-icon>
                                      </v-layout>

                                        <v-layout  v-if="savedSchool.healthcare_experience_direct_paid_patient_hours === true" mt-2 row   align-center justify-space-between mx-0>
                                          <span class=" font-weight-light black--text ">Paid Direct Patient Care</span>
                                          <v-icon color="blue darken-3" class="" size="20px">mdi-check-circle</v-icon>
                                        </v-layout>
                                        <v-divider v-if="savedSchool.healthcare_experience_direct_paid_patient_hours === true" class="mt-2 mb-1 "></v-divider>

                                        <v-layout v-if="savedSchool.healthcare_experience_direct_patient_hours === true " mt-2 row   align-center justify-space-between mx-0>
                                          <span class="font-weight-light black--text">Direct Patient Care </span>
                                          <v-icon color="blue darken-3" class="" size="20px">mdi-check-circle</v-icon>
                                        </v-layout>
                                        <v-divider v-if="savedSchool.healthcare_experience_direct_patient_hours === true "  class="mt-2 mb-1 "></v-divider>

                                        <v-layout v-if="savedSchool.healthcare_experience_indirect_patient_hours === true" mt-2 row   align-center justify-space-between mx-0>
                                          <span class="font-weight-light black--text">Indirect Patient Care </span>
                                          <v-icon color="blue darken-3" class="" size="20px">mdi-check-circle</v-icon>
                                        </v-layout>
                                        <v-divider v-if="savedSchool.healthcare_experience_indirect_patient_hours === true"  class="mt-2 mb-1 "></v-divider>

                                        <v-layout v-if="savedSchool.healthcare_experience_volunteer_hours === true" mt-2 row   align-center justify-space-between mx-0>
                                          <span class="black--text font-weight-light">Volunteer</span>
                                          <v-icon color="blue darken-3" class="" size="20px">mdi-check-circle</v-icon>
                                        </v-layout>
                                        <!-- MINIMUM VOLUNTEER HOURS NEED TO BE COMPLETED WITHIN -->
                                        <v-layout v-if="savedSchool.healthcare_experience_minimum_volunteer_hours !== '' && savedSchool.healthcare_experience_minimum_volunteer_hours !== undefined " row   mt-1 >
                                          <span class="ml-3  grey--text ">  Minimum Volunteer Hours: <span class="font-weight-bold red--text">{{savedSchool.healthcare_experience_minimum_volunteer_hours}} hrs</span> </span>
                                        </v-layout>
                                        <v-divider v-if="savedSchool.healthcare_experience_volunteer_hours === true" class="mt-2 mb-1 "></v-divider>



                                  </v-layout>

                                  </v-card-text>
                                </v-card>

                                <!-- ACCEPTED EXPERIENCE DIALOG -->
                                <v-dialog
                                    v-model="showAcceptedExpDialog"
                                    scrollable
                                    max-width="400"
                                    persistent
                                    style="zIndex:2000"
                                  >

                                  <v-card style="borderRadius:10px">
                                      <v-card-title class="title grey lighten-2 text-xs-center mb-2">
                                        Healthcare Experience Hours
                                      </v-card-title>
                                      <v-card-text class="text-xs-justify" >
                                        Each program's definitions and requirements of patient/healthcare experience vary. If you have any questions about your experiences fulfilling an individual program's patient/healthcare experience requirements, contact that program directly.
                                      </v-card-text>

                                      <v-card-text class="pt-0" >
                                        <v-subheader class="pl-0 black--text" style="height:30px">Paid Direct Patient Care Experience:</v-subheader>
                                        Paid experiences in which you are directly responsible for a patient's care.
                                      </v-card-text>

                                      <v-card-text class="pt-0" >
                                        <v-subheader class="pl-0 black--text" style="height:30px">Direct Patient Care Experience:</v-subheader>
                                          Non-paid (volunteer) experiences in which you are directly responsible for a patient's care.

                                      </v-card-text>

                                      <v-card-text class="pt-0" >
                                        <v-subheader class="pl-0 black--text" style="height:30px">Indirect Patient Care Experience:</v-subheader>
                                          Both paid and unpaid (volunteer) experiences in a health or health-related field where you are not directly responsible for a patient's care, but may still have patient interaction.

                                      </v-card-text>
                                      <v-card-actions>
                                          <v-btn @click="showAcceptedExpDialog = false" block color="red" class="elevation-0" dark >Close</v-btn>
                                        </v-card-actions>

                                  </v-card>

                                </v-dialog>


                            </v-tab-item>

                            <!-- My Hours Tab Item-->
                            <v-tab-item class="pb-2">
                              <!-- Hours -->
                              <v-layout mt-4 mb-2 column align-center justify-center>
                                <v-progress-circular :width="3" size="80" :value=100  color="grey"> <span class="percentageValue headline   blue--text text--darken-3 font-weight-medium ">{{totalUserHealthcareHours | round}}</span></v-progress-circular>
                                <span class="mt-1 font-weight-light">My Total Hours</span>
                              </v-layout>
                              <!-- My Hours Break Down -->
                              <v-card style="borderRadius:5px" outlined class="mt-4 mx-2">
                                <v-layout align-center justify-center class=" primary pb-2 ">
                                  <v-icon small class="mr-2 mt-2" color="white">mdi-account-circle</v-icon>
                                  <span class="subtitle-1 mt-2 font-weight-regular white--text">  My Healthcare Hours </span>
                                </v-layout>

                                <v-card-text class="pt-2  ">
                                  <v-layout  column class="pl-0 ml-0 ">


                                      <v-layout  v-if="savedSchool.healthcare_experience_direct_paid_patient_hours === true" mt-2 row   align-center justify-space-between mx-0>
                                        <span class=" font-weight-light black--text ">Paid Direct Patient Care</span>
                                        <span class="body-1">{{totalDirectPaidHours}} hrs</span>
                                      </v-layout>
                                      <v-divider v-if="savedSchool.healthcare_experience_direct_paid_patient_hours === true" class="mt-2 mb-1 "></v-divider>

                                      <v-layout v-if="savedSchool.healthcare_experience_direct_patient_hours === true " mt-2 row   align-center justify-space-between mx-0>
                                        <span class="font-weight-light black--text">Direct Patient Care </span>
                                        <span class="body-1">{{totalDirectHours}} hrs</span>
                                      </v-layout>
                                      <v-divider v-if="savedSchool.healthcare_experience_direct_patient_hours === true "  class="mt-2 mb-1 "></v-divider>

                                      <v-layout v-if="savedSchool.healthcare_experience_indirect_patient_hours === true" mt-2 row   align-center justify-space-between mx-0>
                                        <span class="font-weight-light black--text">Indirect Patient Care </span>
                                        <span class="body-1">{{totalIndirectHours}} hrs</span>
                                      </v-layout>
                                      <v-divider v-if="savedSchool.healthcare_experience_indirect_patient_hours === true"  class="mt-2 mb-1 "></v-divider>

                                      <v-layout v-if="savedSchool.healthcare_experience_volunteer_hours === true" mt-2 row   align-center justify-space-between mx-0>
                                        <span class="black--text font-weight-light">Volunteer</span>
                                        <span class="body-1">{{totalVolunteerHours}} hrs</span>
                                      </v-layout>
                                      <!-- MINIMUM VOLUNTEER HOURS NEED TO BE COMPLETED WITHIN -->
                                      <v-layout v-if="savedSchool.healthcare_experience_minimum_volunteer_hours !== '' && savedSchool.healthcare_experience_minimum_volunteer_hours !== undefined " row   mt-1 >
                                        <span class="ml-3  grey--text ">  Minimum Volunteer Hours: <span class="font-weight-bold red--text">{{savedSchool.healthcare_experience_minimum_volunteer_hours}} hrs</span> </span>
                                      </v-layout>
                                      <v-divider v-if="savedSchool.healthcare_experience_volunteer_hours === true" class="mt-2 mb-1 "></v-divider>



                                </v-layout>

                                </v-card-text>
                              </v-card>


                            </v-tab-item>
                          </v-tabs-items>







                        </v-card>

                        <!-- Healthcare Notes -->
                        <v-card v-if="savedSchool.healthcareNotes" outlined class=" mt-4 mb-4">
                          <v-layout align-center justify-center class=" pb-1" >
                            <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
                            <span class="font-weight-light align-center">Additional Notes </span>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-card-text class="text-center">
                            <span>{{savedSchool.healthcareNotes}}</span>
                          </v-card-text>
                        </v-card>

                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Recommended PA Shadowing -->
                  <v-expansion-panels v-if="savedSchool.pa_shadowing_recommended === true" focusable class="px-2 mt-3 ">
                    <v-expansion-panel class="mt-2  "  >
                      <v-expansion-panel-header  class="light-blue--text text--darken-4">
                        <v-layout row align-center pb-0 >
                          <v-icon color="amber darken-3" >mdi-thumb-up</v-icon>
                          <v-icon color="blue darken-3" class="ml-2">mdi-account-multiple</v-icon>
                          <span class="ml-2 blue--text text--darken-3 font-weight-medium">PA Shadowing</span>
                        </v-layout>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content eager class=" px-0 mx-0 pb-0 elevation-0 ">

                        <v-card style="borderRadius:5px" class="elevation-0 innerCardCover" outlined>
                          <v-layout  class="amber darken-3 pb-2 justify-center">
                              <span  class="white--text text-center mt-2">PA Shadowing Recommended</span>
                          </v-layout>
                          <v-tabs
                            v-model="pashadowingHoursTab"
                            background-color="transparent"
                            color="basil"
                            grow
                            class="mt-3 px-2"
                            hide-slider
                            >
                            <v-tab active-class="grey darken-2 white--text" style="marginLeft:0px;">
                              Recommended Hrs
                            </v-tab>

                            <v-tab active-class="primary white--text">
                            <v-icon small class="mr-2" >mdi-account-circle</v-icon>
                              My Hours
                            </v-tab>
                          </v-tabs>

                          <v-tabs-items v-model="pashadowingHoursTab">
                            <!-- Recommended Hours Tab Item -->
                            <v-tab-item class="pb-2">
                              <v-layout  v-if="savedSchool.pa_shadowing_recommended === true" mt-4 mb-2 column align-center justify-center>
                                  <v-progress-circular  v-if="savedSchool.pa_shadowing_recommended_minimum_hours !== '' && savedSchool.pa_shadowing_recommended_minimum_hours !== undefined" :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium amber--text text--darken-3" >{{savedSchool.pa_shadowing_recommended_minimum_hours}}</span></v-progress-circular>
                                  <span v-if="savedSchool.pa_shadowing_recommended_minimum_hours === '' || savedSchool.pa_shadowing_recommended_minimum_hours === undefined " class="  mb-0  body-1 font-weight-light ">No Specified Hours</span>
                                  <span  v-if="savedSchool.pa_shadowing_recommended_minimum_hours !== '' && savedSchool.pa_shadowing_recommended_minimum_hours !== undefined" class="mt-1   font-weight-light">Hours</span>
                            </v-layout>
                            </v-tab-item>

                            <!-- My Hours Tab Item-->
                            <v-tab-item class="pb-2">

                              <v-layout  mt-4 mb-2 column align-center justify-center>
                                  <v-progress-circular   :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium blue--text text--darken-3" >{{totalPaShadowingHours}}</span></v-progress-circular>
                                  <span   class="mt-1   font-weight-light">My Hours</span>
                              </v-layout>



                            </v-tab-item>
                          </v-tabs-items>

                        </v-card>


                        <!-- PA Shadowing Notes -->
                        <v-card v-if="savedSchool.paShadowingNotes" outlined class=" mt-4 mb-4">
                          <v-layout align-center justify-center class=" pb-1" >
                            <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
                            <span class="font-weight-light align-center">Additional Notes </span>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-card-text class="text-center">
                            <span>{{savedSchool.paShadowingNotes}}</span>
                          </v-card-text>
                        </v-card>


                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Recommended Evaluations -->
                  <v-expansion-panels v-if="savedSchool.letter_of_recommendation_recommended === true" focusable class="px-2 mt-3 ">
                    <v-expansion-panel class="mt-2">
                      <v-expansion-panel-header  class="light-blue--text text--darken-4">
                        <v-layout row align-center pb-0 >
                          <v-icon color="amber darken-3" >mdi-thumb-up</v-icon>
                          <v-icon color="blue darken-3" class="ml-2">mdi-account-voice</v-icon>
                          <span class="ml-2 blue--text text--darken-3 font-weight-medium">Evaluations</span>
                        </v-layout>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content eager class=" px-0 mx-0 pb-0 elevation-0 ">
                         <v-card  class="pb-3 mt-3 innerCardCover elevation-0" style="borderRadius:5px" outlined>
                          <v-layout  justify-center class="amber darken-3 pb-2">
                            <span class="white--text text-center mt-2">Evaluations Recommended</span>
                          </v-layout>
                          <v-tabs
                            v-model="evaluationsTab"
                            background-color="transparent"
                            color="basil"
                            grow
                            class="mt-3 px-2"
                            hide-slider
                            >
                            <v-tab active-class="grey darken-2 white--text" style="marginLeft:0px;">
                              Recommended Evals
                            </v-tab>

                            <v-tab active-class="primary white--text">
                            <v-icon small class="mr-2" >mdi-account-circle</v-icon>
                              My Evals
                            </v-tab>
                          </v-tabs>

                          <v-tabs-items v-model="evaluationsTab">
                            <v-tab-item class="pb-2">
                              <v-layout v-if="savedSchool.letter_of_recommendation_recommended"  mt-4 mb-2 column align-center justify-center>
                                <v-progress-circular  v-if="savedSchool.letter_of_recommendation_minimum_letters_required !== ''  " :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium amber--text text--darken-3" >{{savedSchool.letter_of_recommendation_minimum_letters_required}}</span></v-progress-circular>
                                <span v-if="savedSchool.letter_of_recommendation_minimum_letters_required === '' " class="  mb-0  body-1 font-weight-light ">No Specified Evaluations Listed</span>
                                <span  v-if="savedSchool.letter_of_recommendation_minimum_letters_required !== ''" class="mt-1   font-weight-light">Evaluations</span>
                              </v-layout>

                              <v-card v-if="savedSchool.recommendedEvaluationsNotes" outlined class=" mt-4 mb-4">
                      <v-layout align-center justify-center class=" pb-1" >
                        <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
                        <span class="font-weight-light align-center">Additional Notes </span>
                      </v-layout>
                      <v-divider></v-divider>
                      <v-card-text class="text-center">
                        <span>{{savedSchool.recommendedEvaluationsNotes}}</span>
                      </v-card-text>
                    </v-card>
                            </v-tab-item>

                            <!-- My Evals Tab Item-->
                            <v-tab-item class="pb-2">
                              <!-- Evaluations -->
                              <v-layout mt-4 mb-2 column align-center justify-center>
                                <v-progress-circular :width="3" size="80" :value=100  color="grey"> <span class="percentageValue headline   blue--text text--darken-3 font-weight-medium ">{{userEvaluations.length}}</span></v-progress-circular>
                                <span class="mt-1 font-weight-light">Total Evaluations</span>
                              </v-layout>
                              <!-- My Evaluators Break Down -->
                              <v-card style="borderRadius:5px" outlined class="mt-4 mx-2">
                                <v-layout align-center justify-center class=" primary pb-2 ">
                                  <v-icon small class="mr-2 mt-2" color="white">mdi-account-circle</v-icon>
                                  <span class="subtitle-1 mt-2 font-weight-regular white--text"> My Evaluators </span>
                                </v-layout>

                                <v-card-text class="pt-2  ">


                                    <v-layout  v-for="writer in userEvaluations" :key="writer.id" column class="pl-0 ml-0 ">

                                          <v-layout  mt-2 row   align-center mx-0>
                                            <span class="primary--text ">{{writer.writer_name}}</span>
                                            <span class=" font-weight-light black--text ml-1 ">{{writer.writer_title}}</span>
                                          </v-layout>
                                          <span  v-if="writer.writer_time_known !== '' && writer.writer_time_known !== undefined" class="grey--text">Time Known: <span class="font-weight-regular blue--text text--darken-3">{{writer.writer_time_known}} months</span></span>
                                          <span class="" :class="{ 'red--text' : writer.evaluation_status === 'Not Yet Requested', 'amber--text text--darken-3' : writer.evaluation_status === 'Agreed to write evaluation', 'blue--text text--lighten-1' : writer.evaluation_status === 'Submitted to CASPA', 'green--text' : writer.evaluation_status === 'Received' }">{{writer.evaluation_status}}</span>
                                          <v-divider  class="mt-2 mb-1 "></v-divider>
                                      </v-layout>





                                </v-card-text>
                              </v-card>


                            </v-tab-item>
                          </v-tabs-items>
                         </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Recommended CASPer -->
                  <v-expansion-panels v-if="savedSchool.casper_recommended === true" focusable class="px-2 mt-3 ">
                    <v-expansion-panel class="mt-2"  >
                      <v-expansion-panel-header  class="light-blue--text text--darken-4">
                        <v-layout row align-center pb-0 >
                          <v-icon color="amber darken-3" >mdi-thumb-up</v-icon>
                          <v-icon color="blue darken-3" class="ml-2">mdi-file-document</v-icon>
                          <span class="ml-2 blue--text text--darken-3 font-weight-medium">CASPer</span>
                        </v-layout>
                      </v-expansion-panel-header>
                        <v-expansion-panel-content eager class=" px-0 mx-0 pb-0 elevation-0 ">
                          <v-card style="borderRadius:5px" class="innerCardCover elevation-0" outlined >
                            <v-layout   class="amber darken-3 pb-2 justify-center">
                              <span  class="white--text text-center mt-2">CASPer Recommended</span>
                            </v-layout>

                            <v-card-text class="pt-0">
                              <v-layout  mt-3 mb-3 align-center >
                              <span>For more information on the CASPER exam click on the following link.<a class="ml-1" href="https://takecasper.com/">CASPer Exam </a></span>
                              </v-layout>
                            </v-card-text>
                          </v-card>

                          <!-- CASPer Notes -->
                          <v-card v-if="savedSchool.casperNotes" outlined class=" mt-4 mb-4">
                            <v-layout align-center justify-center class=" pb-1" >
                              <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
                              <span class="font-weight-light align-center">Additional Notes </span>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-card-text class="text-center">
                              <span>{{savedSchool.casperNotes}}</span>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                   <!-- Recommended PA-CAT -->
                  <v-expansion-panels v-if="savedSchool.pacat_recommended === true" focusable class="px-2 mt-3 ">
                    <v-expansion-panel class="mt-2  "  >
                      <v-expansion-panel-header  class="light-blue--text text--darken-4">
                        <v-layout row align-center pb-0 >
                          <v-icon color="amber darken-3" >mdi-thumb-up</v-icon>
                          <v-icon color="blue darken-3" class="ml-2">mdi-file-document</v-icon>
                          <span class="ml-2 blue--text text--darken-3 font-weight-medium">PA-CAT</span>
                        </v-layout>
                      </v-expansion-panel-header>
                        <v-expansion-panel-content eager class=" px-0 mx-0 pb-0 elevation-0 ">
                          <v-card style="borderRadius:5px" class="innerCardCover elevation-0" outlined >
                            <v-layout   class="amber darken-3 pb-2 justify-center">
                              <span  class="white--text text-center mt-2">PA-CAT Recommended</span>
                            </v-layout>

                            <v-card-text class="pt-0">
                              <v-layout  mt-3 mb-3 align-center >
                              <span>For more information on the PA-CAT exam click on the following link.<a class="ml-1" href="https://www.pa-cat.com/about-the-pa-cat/" target="_blank">PA-CAT Exam </a></span>
                              </v-layout>
                            </v-card-text>
                          </v-card>

                          <!-- PACAT Notes -->
                          <v-card v-if="savedSchool.pacatNotes" outlined class=" mt-4 mb-4">
                            <v-layout align-center justify-center class=" pb-1" >
                              <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
                              <span class="font-weight-light align-center">Additional Notes </span>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-card-text class="text-center">
                              <span>{{savedSchool.pacatNotes}}</span>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>


                </v-card>

                <!-- School Notes -->
                <v-card  v-if="savedSchool.notes" outlined class="mt-5 pb-1 innerCardCover elevation-0">
                  <v-layout row align-center justify-center class="grey lighten-4 pb-2 mx-0">
                    <span class="title font-weight-regular  align-center mt-1">Notes </span>
                  </v-layout>

                  <v-card-text class="pb-2">
                    <v-layout v-if="savedSchool.school_name !== 'University of North Dakota'" class="pb-2 mx-0">
                      <span class="font-weight-light">{{savedSchool.notes}}</span>
                    </v-layout>

                    <v-layout v-else column mt-2 pb-3>
                    <span>Entry Point 1</span>

                    <span class="font-weight-light">
                      Licensed/Certified Health Care Professional with minimum of 3 years experience.
                      Applicants are accepted from all over the United States.
                    </span>

                    <span class="mt-3">Entry Point 2</span>
                    <span class="font-weight-light">
                      Science-based educational background and minimum of 500 (1000 preferred) hours of direct, supervised patient care.
                      Applicants must be from North Dakota, Montana, Minnesota, or South Dakota.
                    </span>
                  </v-layout>
                  </v-card-text>

                </v-card>

                <!-- Avg Stats Accepted Prior Cycle -->
                <v-card
                  v-if=" savedSchool.gpa_overall_average_accepted_previous_year !== '' || savedSchool.gpa_overall_average_accepted_previous_year !== '' || savedSchool.gpa_science_average_accepted_previous_year !== ''
                  || savedSchool.healthcare_experience_average_accepted_previous_year !== '' && savedSchool.healthcare_experience_average_accepted_previous_year !== undefined
                  ||  savedSchool.pa_shadowing_average_accepted_previous_year !== '' &&  savedSchool.pa_shadowing_average_accepted_previous_year !== undefined
                  || savedSchool.gre_required === true && (savedSchool.gre_average_combined_score_previous_year !== '' && savedSchool.gre_average_combined_score_previous_year !== undefined)
                  || (savedSchool.gre_average_written_score_previous_year !== '' && savedSchool.gre_average_written_score_previous_year !== undefined)
                  || (savedSchool.gre_average_quantitative_score_previous_year !== '' && savedSchool.gre_average_quantitative_score_previous_year !== undefined  )
                  || (savedSchool.gre_average_verbal_score_previous_year !== '' && savedSchool.gre_average_verbal_score_previous_year !== undefined )
                  || (savedSchool.gre_average_combined_percentile_previous_year !== '' && savedSchool.gre_average_combined_percentile_previous_year !== undefined)
                  || (savedSchool.gre_average_written_percentile_previous_year !== '' && savedSchool.gre_average_written_percentile_previous_year !== undefined)
                  || (savedSchool.gre_average_quantitative_percentile_previous_year !== '' && savedSchool.gre_average_quantitative_percentile_previous_year !== undefined  )
                  || (savedSchool.gre_average_verbal_percentile_previous_year !== '' && savedSchool.gre_average_verbal_percentile_previous_year !== undefined )"
                  outlined class="mt-5 pb-5">
                  <v-layout row align-center justify-center class="grey lighten-4 pb-2 mx-0">
                    <span class="title font-weight-regular green--text align-center mt-1">Average Stats Accepted Prior Cycle</span>
                  </v-layout>

                  <!-- Average GPA -->
                  <v-expansion-panels  v-if=" savedSchool.gpa_overall_average_accepted_previous_year !== '' || savedSchool.gpa_overall_average_accepted_previous_year !== '' || savedSchool.gpa_science_average_accepted_previous_year !== '' " focusable  class="px-2">
                    <v-expansion-panel  class="mt-4 "  >
                      <v-expansion-panel-header  >
                         <v-layout row align-center pb-0 >
                          <v-icon color="green" >mdi-chart-areaspline</v-icon>
                          <span class="ml-2 blue--text text--darken-3 font-weight-medium">GPA</span>
                        </v-layout>


                      </v-expansion-panel-header>
                      <v-expansion-panel-content  class=" px-0 mx-0 pb-0 elevation-0" >
                         <!-- Average GPA Accepted Previous Year -->
                              <v-card   class=" elevation-0 innerCardCover mt-2 py-1" style="borderRadius:5px" >

                                <v-layout  align-center justify-space-around>
                                    <!-- Overall GPA -->
                                    <v-layout  v-if=" savedSchool.gpa_overall_average_accepted_previous_year !== '' "  column align-center>
                                        <v-progress-circular :width="3" size="80" :value=100 color="grey"> <span class="percentageValue title font-weight-medium green--text" >{{savedSchool.gpa_overall_average_accepted_previous_year}}</span></v-progress-circular>
                                        <v-layout  align-center class="mt-2">
                                          <span class=" font-weight-light ">Overall</span>
                                        </v-layout>
                                    </v-layout>
                                    <!-- Science GPA -->
                                    <v-layout v-if=" savedSchool.gpa_science_average_accepted_previous_year !== '' "column align-center>
                                      <v-progress-circular :width="3" size="80" :value=100 color="grey"> <span class="percentageValue  title font-weight-medium green--text" >{{savedSchool.gpa_science_average_accepted_previous_year}}</span></v-progress-circular>
                                      <v-layout  align-center class="mt-2">
                                        <span class="  font-weight-light ">Science</span>
                                      </v-layout>

                                    </v-layout>

                                    <!-- Prerequiste GPA -->
                                    <v-layout v-if=" savedSchool.gpa_prerequiste_average_accepted_previous_year !== '' && savedSchool.gpa_prerequiste_average_accepted_previous_year !== undefined " column align-center>
                                      <v-progress-circular :width="3" size="80" :value=100 color="grey"> <span class="percentageValue  title  green--text font-weight-medium " >{{savedSchool.gpa_prerequiste_average_accepted_previous_year}}</span></v-progress-circular>
                                      <v-layout  align-center class="mt-2">
                                        <span class=" font-weight-light ">Prerequisite</span>
                                      </v-layout>
                                    </v-layout>
                                </v-layout >
                              </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Average Healthcare Hours -->
                  <v-expansion-panels  v-if=" savedSchool.healthcare_experience_average_accepted_previous_year !== '' && savedSchool.healthcare_experience_average_accepted_previous_year !== undefined" focusable  class="px-2">
                    <v-expansion-panel  class="mt-4 "  >
                      <v-expansion-panel-header  >
                         <v-layout row align-center pb-0 >
                          <v-icon color="green" >mdi-chart-areaspline</v-icon>
                          <span class="ml-2 blue--text text--darken-3 font-weight-medium">Healthcare Hours</span>
                        </v-layout>


                      </v-expansion-panel-header>
                      <v-expansion-panel-content  class=" px-0 mx-0 pb-0 elevation-0" >
                        <v-card  mt-1 class=" elevation-0 innerCardCover mt-2 py-1" style="borderRadius:5px" >

                            <v-layout v-if=" savedSchool.healthcare_experience_average_accepted_previous_year !== '' && savedSchool.healthcare_experience_average_accepted_previous_year !== undefined"   column align-center justify-center>
                              <v-progress-circular :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium green--text" >{{savedSchool.healthcare_experience_average_accepted_previous_year}}</span></v-progress-circular>
                              <span class="black--text font-weight-light mt-1">Hours</span>
                            </v-layout>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Average PA Shadowing Hours -->
                  <v-expansion-panels  v-if=" savedSchool.pa_shadowing_average_accepted_previous_year !== '' &&  savedSchool.pa_shadowing_average_accepted_previous_year !== undefined " focusable  class="px-2">
                    <v-expansion-panel  class="mt-4 "  >
                      <v-expansion-panel-header  >
                         <v-layout row align-center pb-0 >
                          <v-icon color="green" >mdi-chart-areaspline</v-icon>
                          <span class="ml-2 blue--text text--darken-3 font-weight-medium">PA Shadowing Hours</span>
                        </v-layout>


                      </v-expansion-panel-header>
                      <v-expansion-panel-content  class=" px-0 mx-0 pb-0 elevation-0" >
                        <v-card  mt-1 class=" elevation-0 innerCardCover mt-2 py-1" style="borderRadius:5px" >

                            <v-layout   column align-center justify-center>
                              <v-progress-circular :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium green--text" >{{savedSchool.pa_shadowing_average_accepted_previous_year}}</span></v-progress-circular>
                              <span class="black--text font-weight-light mt-1">Hours</span>
                            </v-layout>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- Average GRE Scores -->
                  <v-expansion-panels
                    v-if="(savedSchool.gre_average_combined_score_previous_year !== '' && savedSchool.gre_average_combined_score_previous_year !== undefined)
                    || (savedSchool.gre_average_written_score_previous_year !== '' && savedSchool.gre_average_written_score_previous_year !== undefined)
                    || (savedSchool.gre_average_quantitative_score_previous_year !== '' && savedSchool.gre_average_quantitative_score_previous_year !== undefined  )
                    || (savedSchool.gre_average_verbal_score_previous_year !== '' && savedSchool.gre_average_verbal_score_previous_year !== undefined )
                    || (savedSchool.gre_average_combined_percentile_previous_year !== '' && savedSchool.gre_average_combined_percentile_previous_year !== undefined)
                    || (savedSchool.gre_average_written_percentile_previous_year !== '' && savedSchool.gre_average_written_percentile_previous_year !== undefined)
                    || (savedSchool.gre_average_quantitative_percentile_previous_year !== '' && savedSchool.gre_average_quantitative_percentile_previous_year !== undefined  )
                    || (savedSchool.gre_average_verbal_percentile_previous_year !== '' && savedSchool.gre_average_verbal_percentile_previous_year !== undefined )"
                   focusable  class="px-2">
                    <v-expansion-panel  class="mt-4 "  >
                      <v-expansion-panel-header  >
                         <v-layout row align-center pb-0 >
                          <v-icon color="green" >mdi-chart-areaspline</v-icon>
                          <span class="ml-2 blue--text text--darken-3 font-weight-medium">GRE Scores</span>
                        </v-layout>


                      </v-expansion-panel-header>
                      <v-expansion-panel-content  class=" px-0 mx-0 pb-0 elevation-0" >

                          <!-- AVERAGE GRE SCORES ACCEPTED -->
                          <v-card  v-if="(savedSchool.gre_average_combined_score_previous_year !== '' && savedSchool.gre_average_combined_score_previous_year !== undefined)
                            || (savedSchool.gre_average_written_score_previous_year !== '' && savedSchool.gre_average_written_score_previous_year !== undefined)
                            || (savedSchool.gre_average_quantitative_score_previous_year !== '' && savedSchool.gre_average_quantitative_score_previous_year !== undefined  )
                            || (savedSchool.gre_average_verbal_score_previous_year !== '' && savedSchool.gre_average_verbal_score_previous_year !== undefined )"
                             style="borderRadius:5px" class="elevation-0 innerCardCover mt-2 py-1" outlined>

                            <v-layout class="grey lighten-3 pb-2 justify-center">
                              <span class="green--text mt-2 text-center mt-2">Average GRE Scores</span>
                            </v-layout>


                            <v-card-text class="pt-2">

                              <!-- COMBINED AVERAGE SCORE -->
                              <v-layout  v-if=" savedSchool.gre_average_combined_score_previous_year !== '' && savedSchool.gre_average_combined_score_previous_year !== undefined"  mt-2 row   align-center justify-space-between mx-0>
                                  <span class=" font-weight-light black--text ">Combined</span>
                                  <span class="ml-4 green--text "> {{savedSchool.gre_average_combined_score_previous_year}}</span>
                              </v-layout>
                              <v-divider v-if="savedSchool.gre_average_combined_score_previous_year !== '' && savedSchool.gre_average_combined_score_previous_year !== undefined"  class="mt-2 mb-1 "></v-divider>

                              <!-- VERBAL SCORE -->
                              <v-layout v-if="savedSchool.gre_average_verbal_score_previous_year !== '' && savedSchool.gre_average_verbal_score_previous_year !== undefined" mt-2 row   align-center justify-space-between mx-0>
                                  <span class=" font-weight-light black--text ">Verbal</span>
                                  <span class="ml-4 green--text"> {{savedSchool.gre_average_verbal_score_previous_year}}</span>
                              </v-layout>
                              <v-divider v-if="savedSchool.gre_average_verbal_score_previous_year !== '' && savedSchool.gre_average_verbal_score_previous_year !== undefined"  class="mt-2 mb-1 "></v-divider>

                              <!-- QUANTITATIVE SCORE -->
                              <v-layout   v-if=" savedSchool.gre_average_quantitative_score_previous_year !== '' " mt-2 row   align-center justify-space-between mx-0>
                                  <span class=" font-weight-light black--text ">Quantitative (Math)</span>
                                  <span class="ml-4 green--text "> {{savedSchool.gre_average_quantitative_score_previous_year}}</span>
                              </v-layout>
                              <v-divider v-if="savedSchool.gre_average_quantitative_score_previous_year !== '' && savedSchool.gre_average_quantitative_score_previous_year !== undefined"  class="mt-2 mb-1 "></v-divider>

                                <!-- ANALYTICAL (WRITING) SCORE -->
                              <v-layout v-if=" savedSchool.gre_average_written_score_previous_year !== '' && savedSchool.gre_average_written_score_previous_year !== undefined " mt-2 row   align-center justify-space-between mx-0>
                                  <span class=" font-weight-light black--text ">Analytical (Writing)</span>
                                  <span class="ml-4 green--text"> {{savedSchool.gre_average_written_score_previous_year}}</span>
                              </v-layout>
                              <v-divider v-if=" savedSchool.gre_average_written_score_previous_year !== '' && savedSchool.gre_average_written_score_previous_year !== undefined "  class="mt-2 mb-1 "></v-divider>




                            </v-card-text>

                          </v-card>

                           <!-- AVERAGE GRE PERCENTILE SCORES ACCEPTED -->
                          <v-card
                            v-if=" (savedSchool.gre_average_combined_percentile_previous_year !== '' && savedSchool.gre_average_combined_percentile_previous_year !== undefined)
                            || (savedSchool.gre_average_written_percentile_previous_year !== '' && savedSchool.gre_average_written_percentile_previous_year !== undefined)
                            || (savedSchool.gre_average_quantitative_percentile_previous_year !== '' && savedSchool.gre_average_quantitative_percentile_previous_year !== undefined  )
                            || (savedSchool.gre_average_verbal_percentile_previous_year !== '' && savedSchool.gre_average_verbal_percentile_previous_year !== undefined )"
                             style="borderRadius:5px"  class="mt-4 elevation-0" outlined>

                            <v-layout class="grey lighten-3 pb-2 justify-center">
                              <span class="green--text mt-2 text-center mt-2">Average GRE Percentile Scores Accepted</span>
                            </v-layout>


                            <v-card-text class="pt-2">

                              <!-- COMBINED AVERAGE SCORE Percentile-->
                              <v-layout  v-if=" savedSchool.gre_average_combined_percentile_previous_year !== '' && savedSchool.gre_average_combined_percentile_previous_year !== undefined"  mt-2 row   align-center justify-space-between mx-0>
                                  <span class=" font-weight-light black--text ">Combined</span>
                                  <span class="ml-4 green--text "> {{savedSchool.gre_average_combined_percentile_previous_year}}%</span>
                              </v-layout>
                              <v-divider v-if="savedSchool.gre_average_combined_percentile_previous_year !== '' && savedSchool.gre_average_combined_percentile_previous_year !== undefined"  class="mt-2 mb-1 "></v-divider>

                              <!-- VERBAL Average SCORE Percentile -->
                              <v-layout v-if=" savedSchool.gre_average_verbal_percentile_previous_year !== '' &&  savedSchool.gre_average_verbal_percentile_previous_year !== undefined" mt-2 row   align-center justify-space-between mx-0>
                                  <span class=" font-weight-light black--text ">Verbal</span>
                                  <span class="ml-4 green--text"> {{savedSchool.gre_average_verbal_percentile_previous_year}}%</span>
                              </v-layout>
                              <v-divider v-if=" savedSchool.gre_average_verbal_percentile_previous_year !== '' &&  savedSchool.gre_average_verbal_percentile_previous_year !== undefined"  class="mt-2 mb-1 "></v-divider>

                              <!-- QUANTITATIVE SCORE -->
                              <v-layout   v-if=" savedSchool.gre_average_quantitative_percentile_previous_year!== '' &&  savedSchool.gre_average_quantitative_percentile_previous_year !== undefined" mt-2 row   align-center justify-space-between mx-0>
                                  <span class=" font-weight-light black--text ">Quantitative (Math)</span>
                                  <span class="ml-4 green--text "> {{savedSchool.gre_average_quantitative_percentile_previous_year}}%</span>
                              </v-layout>
                              <v-divider v-if=" savedSchool.gre_average_quantitative_percentile_previous_year!== '' &&  savedSchool.gre_average_quantitative_percentile_previous_year !== undefined"  class="mt-2 mb-1 "></v-divider>

                                <!-- ANALYTICAL (WRITING) SCORE -->
                              <v-layout v-if=" savedSchool.gre_average_written_percentile_previous_year !== '' && savedSchool.gre_average_written_percentile_previous_year !== undefined " mt-2 row   align-center justify-space-between mx-0>
                                  <span class=" font-weight-light black--text ">Analytical (Writing)</span>
                                  <span class="ml-4 green--text"> {{savedSchool.gre_average_written_percentile_previous_year }}%</span>
                              </v-layout>
                              <v-divider v-if=" savedSchool.gre_average_written_percentile_previous_year !== '' && savedSchool.gre_average_written_percentile_previous_year !== undefined "  class="mt-2 mb-1 "></v-divider>




                            </v-card-text>

                          </v-card>


                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card>

                <v-alert type="info" outlined text dense style="marginBottom:0px; marginTop:30px">
                <span>Information is subject to change by the PA program at any time. If you notice an error please report it to us by clicking the "Report" button above". Thank you for helping us keep myPAbox the most reliable resource for the pre-PA community. - myPAbox Team</span>
                
              </v-alert>

            </v-tab-item>



            <v-tab-item>
              <div id="hyvor-talk-view"></div>

              <hyvor-comments :id="school.id" />
            </v-tab-item>

            <v-tab-item v-if="faqs.length">
              <v-expansion-panels focusable class="px-2 mt-8 ">

                <!-- <v-select
                  :items="faqCatgories"
                  item-text="name"
                  item-value="id"
                  v-model="faqCategoryFilter"
                  label="Filter by Category"
                  solo
                ></v-select> -->

                <div class="filterSpacerCover">
                  <ul class="filterSpacer">
                    <li v-for="faqCategory in faqCatgories" :key="faqCategory.id" class="filterSpacer__li">
                      <v-btn medium rounded :class="[faqCategoryFilter == faqCategory.id ? 'primary' : '']" @click="faqCategoryFilter = faqCategory.id" >
                        {{faqCategory.name}}
                      </v-btn>
                    </li>
                  </ul>
                </div>
                <div v-if="faqCategoryFilter" class="filterSpacerCoverReset">
                  <v-btn medium @click="faqCategoryFilter = null" class="">
                    <v-icon>mdi-close</v-icon> Reset
                  </v-btn>
                </div>

                <v-text-field
                  label="Solo"
                  clearable
                  v-model="searchFaq"
                  placeholder="Search"
                  solo
                ></v-text-field>
                
                <v-expansion-panel class="mt-2" v-for="faq in visibleFaqs" :key="faq.index">
                  <v-expansion-panel-header  class="light-blue--text text--darken-4">
                    <v-layout row align-center pb-0 pr-8 v-html="faq.question"></v-layout>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager class="pt-4 px-0 mx-0 pb-0 elevation-0 ">
                    <div class="py-4" v-html="faq.answer"></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div class="px-4" v-if="visibleFaqs.length == 0">no results founds...</div>
            </v-tab-item>

          </v-tabs-items>

        </v-col>
     </v-row>

    </v-container>


        <!-- Back Button -->
       <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red" style="zIndex:1" fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>
    </div>
  </div>
</template>

<script>

  import { isGradePassed, trim, yearsFromNow, daysFromYearsAgo, filterZeroArrays, getCoursesFromColleges, empty, totalCourseCredits, getTotalLoggedHours, handleize, coursesWithCreditsTotal } from '@/lib/utils'
  import { calculateTotalCreditPoints, totalCASPAGPA, totalGPA, calculateCoursesCreditsTotal  } from '@/store/modules/mygrades'
  import moment from 'moment'
  import userMixins from '@/mixins/usersmixin'
  import schoolMixin from '@/mixins/schoolmixin'
  import checkDegreeMixin from '@/mixins/requirementchecks/checkdegreemixin'
  import checkGPAMixin from '@/mixins/requirementchecks/checkgpamixin'
  import checkPrerequisitesMixin from '@/mixins/requirementchecks/checkprerequisitesmixin'
  import checkHealthcareExperienceMixin from '@/mixins/requirementchecks/checkhealthcareexperiencemixin'
  import checkPaShadowingMixin from '@/mixins/requirementchecks/checkpashadowingmixin'
  import checkEvaluationMixin from '@/mixins/requirementchecks/checkevaluationmixin'
  import checkGreMixin from '@/mixins/requirementchecks/checkgremixin'
  import checkCasperMixin from '@/mixins/requirementchecks/checkcaspermixin'
  import checkpacatMixin from '@/mixins/requirementchecks/checkpacatmixin'
  import checkInternationalExamsMixin from '@/mixins/requirementchecks/checkinternationalexamsmixin'
  import overallCheckMixin from '@/mixins/requirementchecks/overallmixin'
  import HyvorComments from '@/components/HyvorComments'
  import * as firebase from 'firebase'

  export default {
    mixins: [schoolMixin, userMixins,overallCheckMixin,checkDegreeMixin, checkGPAMixin, checkPrerequisitesMixin, checkHealthcareExperienceMixin, checkPaShadowingMixin, checkEvaluationMixin, checkGreMixin, checkCasperMixin, checkInternationalExamsMixin, checkpacatMixin ],
    data() {
      return {
        searchFaq: '',
        faqCategoryFilter: null,
        faqs: [],
        oldDesign: false,
        tab: null,
        recommendedHealthcareHoursTab: null,
        pashadowingHoursTab: null,
        evaluationsTab: null,
        showStatusDialog: false,
        writeFunction: false,
        showPbtDialog: false,
        show : false,
        modal: false,
        alert: false,
        AddCourseDialog : false,
        showAddressDialog: false,
        showCaspaDeadlineTypeDialog: false,
        showStatusInfo: false,
        showPanceInfoDialog: false,
        showAcceptedExpDialog: false,
        college_name: '',
        degree: 'In Progress',
        college_date: '',
        college_term_system: '',
        user_colleges: [],
        drawer: true,
        items: [
          { title: 'Home', icon: 'dashboard' },
          { title: 'About', icon: 'question_answer' }
        ],
        mini: true,
        right: null,
        fixedHeaderFixerVal: 100,
        spacingTop: 0
      }
    },
    components: {
      HyvorComments
    },
    methods: {
      back() {
        this.$router.go("-1");
      },
      getColor(item) {
        if (item) {
          return 'green'
        } else  {
          return 'red'
        }
      },
      getResize() {
        if (this.$refs.fixedHeaderFixer) {
          this.fixedHeaderFixerVal = this.$refs.fixedHeaderFixer && this.$refs.fixedHeaderFixer.scrollHeight + 10
          this.spacingTop = this.fixedHeaderFixerVal && this.fixedHeaderFixerVal > 125 ? '90px' : '50px'
          if ( 768 > window.innerWidth ) {
            document.querySelector('.v-slide-group__prev--disabled').style.flexBasis = 0
            document.querySelector('.v-slide-group__prev--disabled').style.minWidth = 0
          }
        }
      }
    },
    mounted(){
      window.addEventListener('resize', this.getResize)
      this.fetchFaqs()
    },
    updated() {
      this.getResize()
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getResize)
    },
    computed: {
      id () {
        return this.$route.params.id
      },
      school() {
       const findSchool = this.savedSchools.find(school => school.school_name.split('-').join(' ') === this.id.split('-').join(' '));
        return findSchool
     
    },
      changeColor () {
        if(this.progressStats.passed / this.progressStats.total * 100 === 100) {
          return 'green'
        }
        else {
          return 'red'
        }
      },
      savedSchool () {
        const findSchool = this.savedSchools.find(school => school.school_name.split('-').join(' ') === this.id.split('-').join(' '));
        return findSchool
      },
       savedSchools() {
      return this.$store.getters.savedSchools;
    },

      totalUserCertifications () {
        let totalUserCertifications = 0
        let userCertifications = this.certificationsInfo
        if(this.savedSchool.cpr) {
          userCertifications.find((certification) => {
             if(certification.certification_type === 'CPR') {
              totalUserCertifications += 1
              }
          })
        }
        if(this.savedSchool.basic_life_support) {
          userCertifications.find((certification) => {
             if(certification.certification_type === 'BLS') {
               totalUserCertifications += 1
              }
          })
        }
        if(this.savedSchool.acls) {
          userCertifications.find((certification) => {
             if(certification.certification_type === 'ACLS') {
               totalUserCertifications += 1
              }
          })
        }
        return totalUserCertifications
      },

      calculatePendingEvaluations() {
        var pendingEvaluations = this.savedSchool.letter_of_recommendation_minimum_letters_required


        // Check if pending letters is less than length of required writer title
        if(this.savedSchool.letter_of_recommendation_minimum_letters_required > this.savedSchool.letter_of_recommendation_specific_writers_title.length) {
          return pendingEvaluations -= this.userEvaluations.length
        }


        if(this.savedSchool.letter_of_recommendation_specific_writers_required === false) {
          return pendingEvaluations -= this.savedSchool.letter_of_recommendation_minimum_letters_required
        }

        for(var r = 0; r < this.savedSchool.letter_of_recommendation_specific_writers_title.length; r++) {

          for(var e = 0; e < this.userEvaluations.length; e++) {
            if(this.savedSchool.letter_of_recommendation_specific_writers_title[r].writer_title === this.userEvaluations[e].writer_title){
              pendingEvaluations -= 1
            }

          }
        }
        return pendingEvaluations
      },

    },
    filters: {
      removeCharacters(string) {
        if(string !== 0) {
          return string.replace(/[^a-zA-Z ]/g, "");
        }
      },
      capitalizeString(string) {
        if(string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
        }

        },
        alphabeticalOrder(string) {
            return string.sort((courseA, courseB) => {
        if(courseA.course_name < courseB.course_name) {
         return -1;
        }
        if(courseA.course_name > courseB.course_name) {
          return 1;
        }
        })

        }
    },
    beforeMount : function (){
       window.scrollTo(0, 0);
    }
  }
</script>

<style scoped>

.v-expansion-panel::before {
   box-shadow: 0 10px 20px -10px rgba(0,0,0,.19)  !important;
}
@media (max-width: 900px) {
  .schoolTabs {
    margin-top: 60px !important;
  }

}
.card {
  padding-top: 10px;
  background-color: rgb(255, 255, 255);
}
.cards {
  border-radius: 10px;
  background-color: rgb(255, 255, 255);
}

#schoolToolbar {
  position: sticky;
  box-shadow: 0 10px 30px -10px #11111130;

}

.button {
  width:100%;
}
a {
  text-decoration: none;
}
.schoolName {
  font-size: 20px;
}

.toolbarContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

img {
  width: 50px;
  height: 50px;
}




h2 {
  color: rgb(87, 87, 87);
  margin-left: 10px;
}

.tabContent {
  margin-top: 5px;
}

.closeButton {
  bottom: 0;

  height:40px;
  background-color: white;

}

#borderCard {
  border: 1px solid rgb(228, 228, 228);
}

 .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:60px;

  }

#buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}

#secondaryButtonShadow {
  box-shadow: 0 10px 20px -11px rgba(0,0,0,.19);
  border-radius: 10px;
}

.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}
.headerFake {
  position: relative;
  text-align: center;
}

@media (min-width: 960px) {
  .headerFake .v-toolbar__title {
    font-size: 30px;
    padding-bottom: 12px;
  }
}


.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
  .container {
    max-width: 60%;
  }
}
.headerFake #Report {
  display: inline-block;
  vertical-align: middle;
}
.headerFake__buttonCover {
    padding: 30px 0 10px;
}
.headerFake__buttonCover .v-btn .caption {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
}
.headerFake__buttonCover .v-btn + .v-btn{
  margin-left: 40px;
}

.innerCardCover {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  border-radius: 5px;
  padding: 0;
  margin-top: 12px;
}

/* @media (min-width: 960px) {
  .innerCardCover {
    padding: 16px;
  }
} */

.filterSpacerCover {
  display: block;
  width: 100%;
}
.filterSpacerCoverReset {
  display: block;
  width: 100%;
  text-align: right;
  margin: 0 0 20px;
}

.filterSpacer {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0 0 20px;
  width: 100%;

}

.filterSpacer__li {
  margin: 10px;
}

.wrap {
  margin-top:8vh;
}

@media (min-width: 900px) {
  .wrap {
    margin-top: 8vh !important;
    
  }
}

</style>

<style>
.innerCardCover {
  width:100%;
}
</style>




// WEBPACK FOOTER //
// src/components/Dashboard/SavedSchools/SavedSchoolInfo.vue